module.exports = __webpack_public_path__ + "static/media/stool.59a81796.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/floorPlan/stool.svg
// module id = 1062
// module chunks = 36